import { render, staticRenderFns } from "./SupervisorWorkerCards.vue?vue&type=template&id=023ae8ec&scoped=true"
import script from "./SupervisorWorkerCards.vue?vue&type=script&lang=js"
export * from "./SupervisorWorkerCards.vue?vue&type=script&lang=js"
import style0 from "./SupervisorWorkerCards.vue?vue&type=style&index=0&id=023ae8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ae8ec",
  null
  
)

export default component.exports